import React from "react";
import { IconProps } from "./IconProps";

const ChevronArrowDown: React.FC<IconProps> = ({
    size = 16,
    color = "#F7F9F9",
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 17 16"
            fill="none"
            {...props}
        >
            <path
                d="M5.16663 10.0003L8.49996 13.3337L11.8333 10.0003"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ChevronArrowDown;
